import { useEffect } from 'react';
import { useToast } from '../contexts/ToastContext';
import { setApiToast } from '../lib/api';

export default function ApiToastBridge() {
  const toast = useToast();

  useEffect(() => {
    setApiToast(toast);
  }, [toast]);

  return null;
}
